<template>
    <div class="sessiontimeouts-page">
        <div class="page-head">
            <div class="left">
                <h1>Set session timeouts</h1>
            </div>
        </div>
        <SessionForm></SessionForm>
    </div>
</template>

<script>
    import SessionForm from '@/components/SessionTimeouts/SessionForm'
    export default {
        name: "SessionTimeouts",
        components: {
            SessionForm
        },

        methods: {

        },
        mounted() {}
    };
</script>

<style scoped></style>
